import SeeOnMap from "../../../../components/admin/common/details-components/SeeOnMap";

const PropertyTitleCard = ({ property }) => {
  const title = property?.title || "Property Title";

  return (
    <div className="p-4 sm:p-6 bg-white rounded-xl  shadow-sm border border-gray-200">
      <div className="flex flex-col gap-2">
        <h2 className="text-xl font-semibold text-gray-900 leading-normal">
          {title}
        </h2>
        <SeeOnMap location={property?.location} className="mt-2" />
      </div>
    </div>
  );
};
export default PropertyTitleCard